import script from "./birthdayChange.vue?vue&type=script&setup=true&lang=js"
export * from "./birthdayChange.vue?vue&type=script&setup=true&lang=js"

import "./birthdayChange.vue?vue&type=style&index=0&id=7bc69de6&lang=scss"

const __exports__ = script;

export default __exports__